import FixedAspectRatioImg from "parent/src/js/base/Controllers/FixedAspectRatioImg";

class DefaultHero {
	/**
	 * @type {HTMLElement|null}
	 */
	el = null;
	/**
	 * @type {FixedAspectRatioImg|null}
	 */
	fixedAspectRatioImg = null;
	constructor(el) {
		this.el = el;

		if (this.el) {
			if (this.el.classList.contains("maintain-aspect-ratio")) {
				this.fixedAspectRatioImg = new FixedAspectRatioImg(this.el.querySelector(".maintain-aspect-ratio img"));

				window.addEventListener("resize", this.onWindowResize.bind(this));

				this.updateSize();
			}
		}
	}

	updateSize() {
		this.el.style.minHeight = this.fixedAspectRatioImg.getRealHeight().toString().concat("px");
	}

	onWindowResize() {
		this.updateSize();
	}
}

export default DefaultHero;
